import logo from './logo.svg';
import './App.css';
import { Routes, Route, Outlet, Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import Login from "./pages/login";
import Register from "./pages/register";
import Vimeo from "./pages/vimeo";
import 'react-confirm-alert/src/react-confirm-alert.css';
import LandingPage from "./pages/landing-page";
import SendCCPE from "./pages/send-ccpe";
import Forgot from "./pages/forgot";

function App() {
  return <>
      <Routes>
          <Route path="/welcome" element={<LandingPage/>}/>
          <Route path="/login" element={<Login/>}/>
          <Route path="/forgot" element={<Forgot/>}/>
          <Route path="/register" element={<Register/>}/>
          <Route path="/vimeo/:courseID" element={<Vimeo/>}/>
          <Route path="/ccpe" element={<SendCCPE/>}/>
      </Routes>
      <NotificationContainer/>
  </>
}

export default App;
